<template>
<file-layout :show-header="isPublic" :file-name="fileName" :allow-share="false">
    <div v-if="isPcMode" class="pc-folder-view">
      <div class="viewbox">
        <div class="nav">
          <div class="left">
            <div class="nav-item" v-for="item of paths" :key="item.fileId">
              <a href="javascript:void(0)" @click="openItem(item)">
                {{ item.fileName }}
              </a>
              <svg-icon icon-class="arrow-forward"></svg-icon>
            </div>
          </div>
          <div class="right">
            <div class="loading">
              <img v-if="isLoading" class="img" src="@/assets/h5/loading2.gif">
              <div class="view-mode-switch" :aria-label="$t('文件展示模式#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1')">
                <moo-tooltip v-for="mode in viewModes" :key="mode.value" :content="mode.label" effect="light" placement="top" popper-class="directory-view-mode-tooltip" :visible-arrow="false">
                  <button type="button" :class="[
                      'view-mode-button',
                      { 'is-active': viewMode === mode.value },
                    ]" :aria-label="mode.label" @click="setViewMode(mode.value)">
                    <svg-icon :icon-class="mode.icon"></svg-icon>
                  </button>
                </moo-tooltip>
                <span class="view-mode-divider"></span>
              </div>
              <UploadPopper :fid="this.fileId" :isRead="isRead" :toolTip="uploadToolTip" @handleUpload="handleUpload"></UploadPopper>
              <CreatePopper @handleFolderDialog="handleFolderDialog" :isRead="isRead" :isLogin="isLogin" :isHeader="false" @handleCreate="handleCreate"></CreatePopper>
            </div>
          </div>
        </div>
        <div :class="['list', 'directory-list', `view-mode-${viewMode}`]">
          <div v-if="viewMode === 'list'" class="list-header">
            <div class="prefix"></div>
            <div class="type">
              <span>{{$t("类型#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="name">
              <span>{{$t("文件名称#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="owner">
              <div class="separator"></div>
              <span>{{$t("所有者#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="size">
              <div class="separator"></div>
              <span>{{$t("最近更新#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="size">
              <div class="separator"></div>
              <span>{{$t("大小#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
            </div>
            <div class="action">
              <span></span>
            </div>
          </div>
          <div class="list-body">
            <div v-if="isEmpty" class="empty">
              <div class="message">
                <img src="@/assets/h5/notfound.png">
                <div>
                  <span>{{$t("该文件夹内无文件#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1")}}</span>
                </div>
              </div>
            </div>
            <div class="result" v-infinite-scroll="load" infinite-scroll-distance="60" :infinite-scroll-disabled="disabled" :infinite-scroll-immediate="immediate">
              <template v-if="viewMode === 'list'">
                <div class="row" v-for="item of source" :key="item.fileId">
                  <div class="prefix"></div>
                  <div class="type" @click="openItem(item)">
                    <div>
                      <div class="icon-container" v-show="showSvgIcon(item)">
                        <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
                        <pcShortCut v-if="item.shortcut === true" :class="[
                            'icon-shortcut',
                            item.type === '1' ? 'icon-shortcut-dir' : '',
                          ]"></pcShortCut>
                      </div>
                      <div v-if="isPicture(item.fileName)" v-show="!showSvgIcon(item)" class="img-box">
                        <img @error="onImageError(item)" @load="onImageLoad(item)" :src="imgSrc(item)">
                      </div>
                    </div>
                  </div>
                  <div class="name">
                    <a href="javascript:void(0)" @click="openItem(item)">
                      {{ item.fileName }}
                    </a>
                    <svg-icon v-if="isTemplate(item)" :class="[
                        'template_icon',
                        cloudI18n === 'en-us' ? 'template_icon_en' : '',
                      ]" :icon-class="
                        cloudI18n === 'en-us'
                          ? 'template_mark_en'
                          : 'template_mark'
                      "></svg-icon>
                  </div>
                  <div class="owner">
                    <span>{{ formatOwner(item) }}</span>
                  </div>
                  <div class="size">
                    <span>{{ formatTime(item) }}</span>
                  </div>
                  <div class="size">
                    <span>{{ formatFileSize(item) }}</span>
                  </div>
                  <div class="action">
                    <moo-dropdown v-show="menuFilter(item).length > 0" trigger="click" @command="handleMenu">
                      <div class="action-tab">
                        <svg-icon icon-class="file-more"></svg-icon>
                      </div>
                      <moo-dropdown-menu slot="dropdown">
                        <moo-dropdown-item :command="{ ...data, ...item }" v-for="data in menuFilter(item)">
                          {{ data.name }}
                        </moo-dropdown-item>
                      </moo-dropdown-menu>
                    </moo-dropdown>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="item of source" :key="item.fileId" :class="['view-card', `${viewMode}-card`]" @click="openItem(item)">
                  <div :class="[
                      'card-action',
                      { 'is-menu-visible': activeMenuFileId === item.fileId },
                    ]">
                    <moo-dropdown v-show="menuFilter(item).length > 0" trigger="click" @command="handleMenu" @visible-change="handleCardMenuVisibleChange($event, item.fileId)">
                      <div class="action-tab" @click.stop="">
                        <svg-icon icon-class="file-more"></svg-icon>
                      </div>
                      <moo-dropdown-menu slot="dropdown">
                        <moo-dropdown-item v-for="data in menuFilter(item)" :key="data.operation" :command="{ ...data, ...item }">
                          {{ data.name }}
                        </moo-dropdown-item>
                      </moo-dropdown-menu>
                    </moo-dropdown>
                  </div>
                  <div class="card-icon">
                    <div class="icon-container" v-show="showSvgIcon(item)">
                      <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
                      <pcShortCut v-if="item.shortcut === true" :class="[
                          'icon-shortcut',
                          item.type === '1' ? 'icon-shortcut-dir' : '',
                        ]"></pcShortCut>
                    </div>
                    <div v-if="isPicture(item.fileName)" v-show="!showSvgIcon(item)" class="img-box">
                      <img @error="onImageError(item)" @load="onImageLoad(item)" :src="imgSrc(item)">
                    </div>
                  </div>
                  <a href="javascript:void(0)" class="card-name" :title="item.fileName" @click.stop="openItem(item)">
                    {{ item.fileName }}
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h5-folder-view">
      <div class="list-body">
        <div v-if="isEmpty" class="empty">
          <div class="message">
            <img src="@/assets/h5/notfound.png">
            <div>
              <span>{{$t("该文件夹内无文件#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_2")}}</span>
            </div>
          </div>
        </div>
        <div class="result" v-infinite-scroll="load" infinite-scroll-distance="60" :infinite-scroll-disabled="disabled" :infinite-scroll-immediate="immediate">
          <div class="row" v-for="item of source" :key="item.fileId" @click="openItem(item)">
            <div class="prefix"></div>
            <div class="type">
              <div>
                <div class="icon-container" v-show="showSvgIcon(item)">
                  <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
                  <mobileShortCut v-if="item.shortcut === true" :class="[
                      'icon-shortcut',
                      item.type === '1' ? 'icon-shortcut-dir' : '',
                    ]"></mobileShortCut>
                </div>
              </div>
              <div v-if="isPicture(item.fileName)" v-show="!showSvgIcon(item)" class="img-box">
                <img @error="onImageError(item)" @load="onImageLoad(item)" :src="imgSrc(item)">
              </div>
            </div>
            <div class="name">
              <div :class="[
                  'filename-container',
                  isTemplate(item) ? '' : 'filename-container-noTemplate',
                ]">
                <span class="caption">
                  {{ item.fileName }}
                </span>
                <svg-icon v-if="isTemplate(item)" :class="[
                    'template_icon',
                    cloudI18n === 'en-us' ? 'template_icon_en' : '',
                  ]" :icon-class="
                    cloudI18n === 'en-us' ? 'template_mark_en' : 'template_mark'
                  "></svg-icon>
              </div>
              <div>
                <span class="size">{{ formatFileSize(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MkdirDialog @openItem="openItem" @refresh="refresh" :fileId="fileId" ref="mkdir" :folderPath="folderPath"></MkdirDialog>
    <RenameDialog :metadata="metadata" :fileName="fileName" :fileId="fileId" ref="rename" :folderPath="folderPath" @refresh="refresh"></RenameDialog>
    <DeleteDialog :fileName="fileName" :fileId="fileId" ref="delete" :folderPath="folderPath" @refresh="refresh"></DeleteDialog>
    <PreCheckFolderUploadDialog @handlUpload="handlePreCheckUpload" ref="preCheck"></PreCheckFolderUploadDialog>
  </file-layout>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapState, mapActions } from "vuex";
import { getFiles, getUserAuthList, checkFile } from "@/api/h5/file";
import FileLayout from "@/components/h5/Layout";
import CreatePopper from "./popper/CreatePopper.vue";
import UploadPopper from "./popper/UploadPopper.vue";
import moment from "moment";
import MkdirDialog from "./dialog/mkdirDialog";
import RenameDialog from "./dialog/renameDialog";
import DeleteDialog from "./dialog/deleteDialog.vue";
import { fileImgName, getDocumentTypeIcon } from "@/utils/avatar";
import mobileShortCut from "../assets/mobileShortCut.vue";
import pcShortCut from "../assets/pcShortCut.vue";
import PreCheckFolderUploadDialog from "@/pages/CloudHome/components/PreCheckFolderUploadDialog.vue";

export default {
  components: {
    FileLayout,
    CreatePopper,
    UploadPopper,
    MkdirDialog,
    RenameDialog,
    DeleteDialog,
    mobileShortCut,
    pcShortCut,
    PreCheckFolderUploadDialog
  },
  props: {
    rootId: {
      type: String
    },
    fileId: {
      type: String
    },
    spaceId: {
      type: String
    },
    auth: {
      type: String
    },
    metadata: {
      type: Object
    },
    isPublic: {
      type: Boolean
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    sameSpace: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: ""
    },
    userInfo: {
      type: Object,
      default: null
    },
    sharePassword: {
      type: String,
      default: ""
    }
  },
  watch: {
    source(val) {
      this.$emit("updateSource", val);
    }
  },
  data() {
    return {
      source: [],
      paths: [],
      iconStatus: [],
      folderVisible: true,
      pager: null,
      isEmpty: false,
      disabled: true,
      immediate: false,
      fileSpaceId: "",
      menuOptions: [
      { name: intl.$t("打开#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "open" },
      { name: intl.$t("下载#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "download" },
      { name: intl.$t("下载为PDF#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "downloadPDF" },
      { name: intl.$t("重命名#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "rename" },
      { name: intl.$t("删除#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), operation: "delete" }],

      clickType: "",
      activeMenuFileId: "",
      viewMode: "list",
      viewModes: [
      { value: "large", label: intl.$t("大图模式#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), icon: "big_img_mode" },
      { value: "list", label: intl.$t("列表模式#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), icon: "list_mode" },
      { value: "grid", label: intl.$t("宫格模式#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"), icon: "grid_mode" }]

    };
  },
  methods: {
    ...mapActions(["setFileAuth"]),
    setViewMode(mode) {
      if (!this.viewModes.some((item) => item.value === mode)) return;
      this.viewMode = mode;
      try {
        window.localStorage.setItem("cloud-directory-view-mode", mode);
      } catch (error) {}
    },
    handleCardMenuVisibleChange(visible, fileId) {
      this.activeMenuFileId = visible ? fileId : "";
    },
    restoreViewMode() {
      try {
        const mode = window.localStorage.getItem("cloud-directory-view-mode");
        if (this.viewModes.some((item) => item.value === mode)) {
          this.viewMode = mode;
        }
      } catch (error) {}
    },
    isTemplate(item) {
      return item.templateType && item.templateType !== 0;
    },
    handleFolderDialog(value) {
      this.$refs.mkdir.handleFolderDialog(value);
    },
    handleRenameDialog(value, item) {
      this.$refs.rename.handleRenameDialog(value, item);
    },
    handleDeleteDialog(value, item) {
      this.$refs.delete.handleDeleteDialog(value, item);
    },
    handleMenu(item) {
      switch (item.operation) {
        case "open":
          return this.openItem(item);
        case "download":
          this.downLoadItem(item);
          return;
        case "downloadPDF":
          this.downLoadItemPDF(item);
          return;
        case "rename":
          this.handleRenameDialog(true, item);
          return;
        case "delete":
          this.handleDeleteDialog(true, item);
          return;
        default:
          break;
      }
    },
    handleCreate(value) {
      this.$emit("handleCreate", value, this.fileId);
    },
    handlePreCheckUpload() {
      this.$emit("handleUpload", this.clickType);
    },
    handleUpload(value) {
      this.clickType = value;
      if (this.clickType === 'file' || this.productType === 'CLOUD_FILE') {
        this.$emit("handleUpload", this.clickType);
      } else {
        this.$refs.preCheck.handleCheckDialog(true);
      }
    },
    refresh() {
      this.resetPager();
      this.load();
    },
    resetPager() {
      this.source = [];
      this.isEmpty = false;
      this.disabled = false;
      this.pager = {
        total: 0,
        since: 0,
        size: 100
      };
    },
    downLoadItem(item) {
      if (item.type === "0") {
        this.$emit("download", item.fileId, false, item);
      } else {
        this.$emit("download", item.fileId, true, item);
      }
    },
    downLoadItemPDF(item) {
      this.$emit("downloadPDF", item);
    },
    openItem(item) {
      if (this.isPcMode && item.type === "0" && this.isPicture(item.fileName)) {
        this.openImagePreview(item);
        return;
      }
      if (item.type === "0") {
        // this.$emit("download", item.fileId);
        // const { origin, pathname } = window.location;
        // var openUrl = origin + pathname + `?fid=${item?.fileId}`;
        // if (pathname == "/web/file") {
        //   openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
        // }
        // window.open(openUrl);
        window.open(item.fileUrl);
      } else {
        this.$emit("open-item", item);
      }
    },

    async openImagePreview(item) {
      try {
        const files = await this.getCurrentFolderFiles();
        const images = files.
        filter((file) => file.type === "0" && this.isPicture(file.fileName)).
        map((file) => ({
          ...file,
          previewUrl: this.imagePreviewSrc(file.fileId)
        }));
        const current = images.find((file) => file.fileId === item.fileId);

        if (!current) return;
        this.$preview({
          current,
          items: images,
          callback: (file) => this.downLoadItem(file)
        });
      } catch (error) {
        this.$message({
          message: intl.$t("图片加载失败#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"),
          type: "error",
          duration: 2000
        });
      }
    },

    async getCurrentFolderFiles() {
      const files = [];
      const pass = this.sharePassword || "";
      const size = 100;
      let since = 0;
      let total = 0;

      do {
        const { code, data = {} } = await getFiles({
          size,
          since,
          password: pass,
          rootId: this.rootId,
          parentId: this.fileId
        });
        if (code !== 200) throw new Error("Unable to load folder files");

        const result = data.result || [];
        files.push(...result);
        total = data.pager ? data.pager.total : files.length;
        since += result.length;

        if (result.length === 0) break;
      } while (since < total);

      return files;
    },

    fileOpen(item) {
      if (item.type === "0") {
        const { origin, pathname } = window.location;
        var openUrl = origin + pathname + `?fid=${item?.fileId}`;
        if (pathname == "/web/file") {
          openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
        }
        window.open(openUrl);
      } else {
        this.$emit("open-item", item);
      }
    },

    load() {
      this.disabled = true;
      const pass = this.sharePassword || "";
      const { size } = this.pager;
      const nextSince = this.source.length;
      const options = {
        size: size,
        since: nextSince,
        password: pass,
        rootId: this.rootId,
        parentId: this.fileId
      };
      getFiles(options).then((e) => {
        this.disabled = false;
        const { code, data } = e;
        if (code !== 200) return;
        const { paths, result, pager } = data;
        this.isEmpty = pager.total === 0;
        this.pager = pager;
        this.paths = paths;
        this.source.push(...result);
      });
    },

    formatFileSize(item, decimals = 2) {
      if (item.type !== "0") return "-";
      const bytes = item.size;
      if (typeof bytes === "string") {
        bytes = parseInt(bytes);
      }
      if (bytes === 0) {
        if (item.storageType === "ONLINE") {
          return '-';
        }
        return "0 B";
      }
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "K", "M", "G", "T", "P", "E", "Z", "Y"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    formatTime(item) {
      return moment(item?.operationTime).format(intl.$t("MM月DD日 HH:mm#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1"));
    },

    formatOwner(item) {
      return item?.creatorInfo?.userName || "-";
    },

    isPicture(name) {
      name = name.trim();
      let index = name.lastIndexOf(".");
      if (index === -1 || index === name.length - 1) return false;
      const ext = name.substr(index + 1).toLowerCase();
      const pic =
      ext === "png" ||
      ext === "jpg" ||
      ext === "jpeg" ||
      ext === "gif" ||
      ext === "bmp" ||
      ext === "ico" ||
      ext === "heic" ||
      ext === "webp";
      return pic;
    },

    getFileIcon(item) {
      const { fileName, type, contentType = "" } = item;
      const documentTypeIcon = getDocumentTypeIcon(contentType);
      if (documentTypeIcon) return documentTypeIcon;
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.
      substr(index).
      replace(".", "").
      toLowerCase();
      return fileImgName(ext);
    },

    onDownloand(item) {
      this.$emit("download", item.fileId);
    },

    getThumbnailVersion(item = {}) {
      if (item.createTime) return item.createTime;
      const fileId = item.fileId || "";
      if (!fileId) return this.thumbnailFallbackVersion;
      if (!this.thumbnailVersionMap) {
        this.thumbnailVersionMap = Object.create(null);
      }
      if (!this.thumbnailVersionMap[fileId]) {
        this.thumbnailVersionMap[fileId] = new Date().getTime();
      }
      return this.thumbnailVersionMap[fileId];
    },

    getThumbnailSize() {
      if (this.viewMode === "large") {
        return {
          width: 690,
          height: 480
        };
      }
      if (this.viewMode === "grid") {
        return {
          width: 216,
          height: 216
        };
      }
      return null;
    },

    buildThumbnailQuery(params) {
      return Object.keys(params).
      filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "").
      map((key) => `${key}=${encodeURIComponent(params[key])}`).
      join("&");
    },

    imgSrc(item) {
      if (!item || !item.fileId) return "";
      const pass = this.sharePassword || "";
      const fileId = item.fileId;
      const size = this.getThumbnailSize();
      const baseParams = {
        v: this.getThumbnailVersion(item),
        ...(size || {})
      };
      const params = this.isPublic ?
      {
        rootId: this.rootId,
        password: pass,
        ...baseParams
      } :
      baseParams;
      const path = this.isPublic ?
      `/public/thumbnail/${fileId}` :
      `/file/thumbnail/${fileId}`;
      const query = this.buildThumbnailQuery(params);
      return `${process.env.VUE_APP_INNERNET_URL}${path}${query ? `?${query}` : ""}`;
    },

    imagePreviewSrc(fileId) {
      const pass = this.sharePassword || "";
      if (this.isPublic) {
        return `${process.env.VUE_APP_INNERNET_URL}/public/preview/${fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      }
      return `${process.env.VUE_APP_INNERNET_URL}/file/preview/other/${fileId}`;
    },

    onImageError(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = -1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: -1
      });
    },

    onImageLoad(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item) {
        item.value = 1;
        return;
      }
      this.iconStatus.push({
        key: e.fileId,
        value: 1
      });
    },

    showSvgIcon(e) {
      const item = this.iconStatus.find((t) => t.key === e.fileId);
      if (item == null) return true;
      if (item.value !== 1) return true;
    },

    async checkFileAuth() {
      const rid = this.$route.query.rid;
      if (!!rid && rid !== this.fileId) {
        try {
          const { data = {}, code = "" } = await checkFile(this.fileId);
          const { auth } = data;
          this.setFileAuth(auth);
          this.fileSpaceId = data?.fileInfo?.spaceId || "";
          this.$emit("floderAuthChange", auth);
        } catch {}
      }
    },
    updateDocInfo(data) {
      // 修改最后一个路径名称
      if (this.paths.length > 0) {
        this.paths[this.paths.length - 1].fileName = data.fileName;
      }
    }
  },
  mounted() {
    this.checkFileAuth();
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      fileAuth: (state) => state.fileAuth,
      cloudI18n: (state) => state.cloudI18n
    }),
    uploadToolTip() {
      return this.productType === "CLOUD_DOCUMENT" ? intl.$t("支持以下文件格式：.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf。#!!!#src/pages/H5/Cloud/components/DirectoryView.vue_1") :

      "";
    },
    isRead() {
      let isDisabled = true;
      const rid = this.$route.query.rid;
      if (!!rid && rid !== this.fileId) {
        isDisabled =
        this.fileAuth == "READ" || this.fileAuth == "READ_DOWNLOAD";
        return isDisabled;
        // return isDisabled || this.spaceId != this.fileSpaceId;
      }
      isDisabled = this.auth == "READ" || this.auth == "READ_DOWNLOAD";
      return isDisabled;
      // return isDisabled || !this.sameSpace;
    },
    folderPath() {
      return this.paths.map((item) => item.fileName).join("/");
    },
    menuFilter(item) {
      return (item) => {
        let menuAuth = item.auth;
        let shortcut = item.shortcut;
        let options = ["open"];
        switch (menuAuth) {
          case "READ":
            return this.menuOptions.filter((item) =>
            options.includes(item.operation)
            );
          case "READ_DOWNLOAD":
            if (shortcut === false) {
              if (item.contentType === "DOCUMENT") {
                options.push("downloadPDF");
              } else {
                //数组后面追加
                options.push("download");
              }
            }
            return this.menuOptions.filter((item) =>
            options.includes(item.operation)
            );
          case "WRITE":
            // 删除delete选项
            if (shortcut === true) {
              return this.menuOptions.filter(
                (item) => item.operation !== "download" && item.operation !== "downloadPDF" && item.operation !== "delete"
              );
            } else {
              if (item.contentType === "DOCUMENT") {
                return this.menuOptions.filter((item) => item.operation !== "download" && item.operation !== "delete");
              } else {
                return this.menuOptions.filter((item) => item.operation !== "downloadPDF" && item.operation !== "delete");
              }
            }
          case "ALL":
            if (shortcut === true) {
              return this.menuOptions.filter((item) => item.operation !== "download" && item.operation !== "downloadPDF");
            }
            if (item.contentType === "DOCUMENT") {
              return this.menuOptions.filter((item) => item.operation !== "download");
            } else {
              return this.menuOptions.filter((item) => item.operation !== "downloadPDF");
            }
        }
      };
    },
    isLoading() {
      const total = this.pager.total;
      const loaded = this.source.length;
      const hasMore = loaded < total;
      return hasMore && this.disabled;
    },
    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    }
  },

  created() {
    this.thumbnailFallbackVersion = new Date().getTime();
    this.thumbnailVersionMap = Object.create(null);
    this.restoreViewMode();
    this.resetPager();
  }
};
</script>

<style lang="scss" scoped>
.pc-folder-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: #ebedef;

  .viewbox {
    display: flex;
    flex-direction: column;
    margin: 20px 5px;
    width: 100%;
    border-radius: 2px;
    max-width: 1400px;
    background: #fff;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);

    .nav {
      display: flex;
      padding: 20px 20px 17px 20px;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;

        .nav-item {
          display: flex;
          align-items: center;

          a {
            font-weight: 400;
            font-size: 13px;
            color: #5c70ff;
            text-decoration: none;

            &:active {
              color: #4959cc;
            }
          }

          svg {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.7);
          }

          &:last-child {
            a {
              text-decoration: none;
              cursor: default;
              font-weight: 400;
              font-size: 13px;
              color: rgba(0, 0, 0, 0.7);

              &:hover {
                color: rgba(0, 0, 0, 0.7);
              }

              &:active {
                color: rgba(0, 0, 0, 0.7);
              }
            }

            svg {
              font-size: 13px;
              color: rgba(0, 0, 0, 0.7);
            }
          }
        }
      }

      .right {
        display: flex;

        @media (max-width: 600px) {
          .loading {
            display: none !important;
          }
        }

        .loading {
          display: flex;
          align-items: center;

          .img {
            width: 16px;
            margin-right: 6px;
          }

          .view-mode-switch {
            display: flex;
            align-items: center;

            .view-mode-button {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 24px;
              height: 24px;
              margin: 0 12px 0 0;
              padding: 0;
              color: #3d4757;
              background: transparent;
              border: 0;
              border-radius: 4px;
              cursor: pointer;

              svg {
                width: 14px;
                height: 14px;
              }

              &:hover,
              &.is-active {
                background: #f5f6f9;
              }
            }

            .view-mode-divider {
              width: 1px;
              height: 12px;
              margin-right: 12px;
              background: #e4e7eb;
            }
          }
        }

        span {
          font-size: 13px;
          color: rgba(0, 0, 0, 0.7);
        }
      }
    }

    @at-root .pc-folder-view .viewbox .directory-list {
      &.view-mode-large,
      &.view-mode-grid {
        .list-body {
          .result {
            display: grid;
            align-content: start;
            overflow: auto;
            flex-direction: initial;
          }
        }
      }

      &.view-mode-large {
        .list-body .result {
          grid-template-columns: repeat(auto-fill, 246px);
          grid-auto-rows: 176px;
        }
      }

      &.view-mode-grid {
        .list-body .result {
          grid-template-columns: repeat(auto-fill, 136px);
          grid-auto-rows: 148px;
        }
      }

      .view-card {
        position: relative;
        display: flex;
        box-sizing: border-box;
        margin: 8px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          .card-action {
            opacity: 1;
            pointer-events: auto;
          }
        }

        .card-action {
          position: absolute;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.15s ease;

          &.is-menu-visible {
            opacity: 1;
            pointer-events: auto;

            .action-tab {
              background: #f4f6f9;
            }
          }

          .action-tab {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            padding: 0 !important;
            color: #3d4757;
            background: rgba(255, 255, 255, 0.88);

            svg {
              width: 12px;
              height: 12px;
            }

            &:hover,
            &:focus {
              background: #f4f6f9;
            }
          }
        }

        .card-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-container {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .icon-shortcut {
            position: absolute;
            left: 4px;
            bottom: 2px;
          }

          .icon-shortcut-dir {
            left: 0 !important;
            bottom: 3px !important;
          }

          .img-box {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              display: block;
              object-fit: contain;
            }
          }
        }

        .card-name {
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-decoration: none;
          text-align: center;
        }
      }

      .large-card {
        width: 230px;
        height: 160px;
        background: #f7f8fb;
        border-radius: 4px;

        .card-action {
          top: 8px;
          right: 8px;
        }

        .card-icon {
          width: 100%;
          height: 100%;

          svg {
            width: 64px;
            height: 64px;
          }

          .img-box {
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }

        .card-name {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          padding: 16px 12px 6px;
          font-weight: 400;
          font-size: 14px;
          color: #fff;
          background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.4));
        }
      }

      .grid-card {
        flex-direction: column;
        width: 120px;
        height: 132px;
        background: #fff;
        border-radius: 4px;

        &:hover {
          background: #f7f7f8;
        }

        .card-action {
          top: 0;
          right: 0;
          left: 0;
          height: 28px;
          padding-right: 4px;
        }

        .card-icon {
          width: 100%;
          height: 68px;
          margin-top: 16px;
          flex-shrink: 0;

          svg {
            width: 56px;
            height: 56px;
          }

          .img-box {
            width: 56px;
            height: 56px;

            img {
              max-width: 56px;
              max-height: 56px;
            }
          }
        }

        .card-name {
          display: block;
          width: 100%;
          padding: 10px 10px 0;
          font-weight: 400;
          font-size: 14px;
          color: #222329;
        }
      }
    }

    .list {
      flex-grow: 1;
      padding: 0px 20px;
      display: flex;
      flex-direction: column;

      .action-tab {
        font-size: 25px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 !important;
        border-radius: 4px;
        cursor: pointer;

        svg {
          width: 17px;
          height: 17px;
        }

        &:hover {
          background: #f4f6f9;
        }
      }

      @media (max-width: 600px) {
        .list-header {
          padding-left: 10px;
          display: flex;
          height: 42px;
          align-items: center;
          background: #f7f7f8;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;

          .separator {
            display: none;
          }

          .prefix {
            width: 1px;
          }

          .type {
            width: 60px;
          }

          .name {
            flex-grow: 1;
          }

          .owner {
            display: flex;
            width: 70px;
            align-items: center;
          }

          .size {
            width: 60px;
          }

          .action {
            width: 70px;
          }

          span {
            font-weight: 500;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }

        .list-body {
          display: flex;
          flex-grow: 1;
          position: relative;

          .empty {
            height: 50%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .message {
              text-align: center;

              img {
                width: 120px;
              }

              span {
                font-size: 17px;
                color: rgba(0, 0, 0, 0.3);
              }
            }
          }

          .result {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            overflow: auto;
            flex-direction: column;

            .row {
              width: 100%;
              display: flex;
              align-items: center;

              .prefix {
                width: 1px;
                height: 60px;
                flex-shrink: 0;
              }

              .type {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                svg {
                  font-size: 38px;
                }

                .icon-container {
                  position: relative;

                  .icon-shortcut-dir {
                    left: 0 !important;
                    bottom: 3px !important;
                  }
                  .icon-shortcut {
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    left: 3px;
                    bottom: 0px;
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .name {
                display: flex;
                align-items: center;
                //flex-grow: 1;
                height: 60px;
                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
                // width: calc(100% - 210px);
                min-width: 60px;

                a {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  text-decoration: none;
                  color: #5c70ff;

                  &:active {
                    color: #4959cc;
                  }
                }

                .template_icon_en {
                  width: 52px !important;
                }
                .template_icon {
                  overflow: unset;
                  width: 28px;
                  height: 16px;
                  margin: 0px 4px;
                }
              }

              .size {
                display: flex;
                align-items: center;
                width: 70px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .owner {
                display: flex;
                align-items: center;
                width: 70px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .action {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;

                  button {
                    width: 64px;
                    height: 30px;
                    background: #ffffff;
                    border: 0.5px solid rgba(0, 0, 0, 0.3);
                    border-radius: 4px;
                    cursor: pointer;

                    &:hover {
                      background: #eaeaea;
                      border: 0.5px solid rgba(0, 0, 0, 0.4);
                    }

                    &:active {
                      background: #e2e2e2;
                      border: 0.5px solid rgba(0, 0, 0, 0.5);
                    }
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }
            }
          }
        }
      }

      @media (min-width: 600px) {
        .list-header {
          display: flex;
          height: 42px;
          align-items: center;
          background: #f7f7f8;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;

          .separator {
            margin-right: 8px;
            width: 1px;
            height: 18px;
            box-shadow: -0.5px 0 rgba(0, 0, 0, 0.1) inset;
          }

          .prefix {
            width: 20px;
          }

          .type {
            width: 60px;
          }

          .name {
            flex-grow: 1;
          }

          .owner {
            display: flex;
            width: 160px;
            align-items: center;
          }

          .size {
            display: flex;
            width: 160px;
            align-items: center;
          }

          .action {
            display: flex;
            width: 160px;
            align-items: center;
          }

          span {
            font-weight: 500;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }

        .list-body {
          display: flex;
          flex-grow: 1;
          min-height: 200px;
          position: relative;

          .empty {
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .message {
              text-align: center;

              img {
                width: 120px;
              }

              span {
                font-size: 17px;
                color: rgba(0, 0, 0, 0.3);
              }
            }
          }

          .result {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            overflow: auto;
            flex-direction: column;

            .row {
              width: 100%;
              display: flex;
              align-items: center;

              .prefix {
                width: 20px;
                height: 60px;
                flex-shrink: 0;
              }

              .type {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                flex-shrink: 0;

                svg {
                  font-size: 38px;
                }

                .icon-container {
                  position: relative;
                  .icon-shortcut-dir {
                    left: 0px !important;
                    bottom: 3px !important;
                  }
                  .icon-shortcut {
                    position: absolute;
                    left: 3px;
                    bottom: 0px;
                  }
                }

                .img-box {
                  width: 36px;
                  height: 36px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  img {
                    overflow: hidden;
                    max-width: 36px;
                    max-height: 36px;
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .name {
                display: flex;
                align-items: center;
                flex-grow: 1;
                height: 60px;
                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
                // width: calc(100% - 900px);
                min-width: 60px;

                a {
                  color: #5c70ff;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  text-decoration: none;

                  &:active {
                    color: #4959cc;
                  }
                }

                .template_icon_en {
                  width: 52px !important;
                }

                .template_icon {
                  overflow: unset;
                  width: 28px;
                  height: 16px;
                  margin: 0px 4px;
                }
              }

              .size {
                display: flex;
                align-items: center;
                width: 160px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .owner {
                display: flex;
                align-items: center;
                width: 160px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;
                  font-weight: 400;
                  font-size: 14px;
                  color: rgba(0, 0, 0, 0.5);
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }

              .action {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 160px;
                height: 60px;
                flex-shrink: 0;

                span {
                  padding-left: 8px;

                  button {
                    width: 64px;
                    height: 30px;
                    background: #ffffff;
                    border: 0.5px solid rgba(0, 0, 0, 0.3);
                    border-radius: 4px;
                    cursor: pointer;

                    &:hover {
                      background: #eaeaea;
                      border: 0.5px solid rgba(0, 0, 0, 0.4);
                    }

                    &:active {
                      background: #e2e2e2;
                      border: 0.5px solid rgba(0, 0, 0, 0.5);
                    }
                  }
                }

                box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
              }
            }
          }
        }
      }
    }
  }
}

.h5-folder-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: #fff;

  .list-body {
    flex-grow: 1;
    position: relative;

    .empty {
      height: 50%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .message {
        text-align: center;

        img {
          width: 120px;
        }

        span {
          font-size: 17px;
          color: rgba(0, 0, 0, 0.3);
        }
      }
    }

    .result {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      overflow: auto;
      flex-direction: column;

      .row {
        width: 100%;
        display: flex;
        align-items: center;

        .prefix {
          width: 20px;
          height: 60px;
          flex-shrink: 0;
        }

        .type {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          flex-shrink: 0;

          svg {
            font-size: 46px;
          }

          .icon-container {
            position: relative;
            .icon-shortcut-dir {
              left: 0px !important;
              bottom: 3px !important;
            }
            .icon-shortcut {
              position: absolute;
              left: 3px;
              bottom: 0px;
            }
          }

          .img-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;

            img {
              overflow: hidden;
              max-width: 36px;
              max-height: 36px;
            }
          }
        }

        .name {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 60px;
          box-shadow: 0 -0.5px rgba(0, 0, 0, 0.1) inset;
          overflow: hidden;

          .filename-container-noTemplate {
            margin-right: 20px;
          }

          .filename-container {
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .caption {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 400;
            font-size: 17px;
            color: #000000;
          }

          .template_icon_en {
            width: 52px !important;
          }
          .template_icon {
            flex-shrink: 0;
            overflow: unset;
            width: 28px;
            height: 16px;
            margin-left: 4px;
            margin-right: 20px;
          }

          .size {
            font-weight: 400;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.directory-view-mode-tooltip {
  padding: 8px !important;
  color: #767c85 !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 24px !important;
  background: #fff !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  margin-bottom: 8px !important;
}
</style>
